// How the invites table words a timestamp. Beside the page rather than in
// it, so the page file exports its component and nothing else.

/** "in 70h" / "in 3d" / "in 18h" — for future timestamps. */
export function humanizeRelativeFuture(
  iso: string,
  now: Date = new Date(),
): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "—";
  const diff = t - now.getTime();
  if (diff <= 0) return "expired";
  const sec = Math.floor(diff / 1000);
  const min = Math.floor(sec / 60);
  if (min < 60) return `in ${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 72) return `in ${hr}h`;
  const day = Math.floor(hr / 24);
  if (day < 14) return `in ${day}d`;
  const wk = Math.floor(day / 7);
  return `in ${wk}w`;
}

/** Hours until expiry (negative if already expired). */
export function hoursUntil(iso: string, now: Date = new Date()): number {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return Number.POSITIVE_INFINITY;
  return (t - now.getTime()) / (1000 * 60 * 60);
}

/** "today · 14:18", "2 days ago", "Mar 14" — for past timestamps. */
export function humanizeSent(iso: string, now: Date = new Date()): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "—";
  const diff = now.getTime() - t;
  if (diff < 0) return "just now";
  const day = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (day === 0) {
    const time = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(iso));
    return `today · ${time}`;
  }
  if (day === 1) return "yesterday";
  if (day < 7) return `${day} days ago`;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
  }).format(new Date(iso));
}

/** "3 days ago", "Mar 14" — for past timestamps without the "today ·" prefix. */
export function humanizePast(iso: string, now: Date = new Date()): string {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "—";
  const diff = now.getTime() - t;
  if (diff < 0) return "just now";
  const day = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (day === 0) return "today";
  if (day === 1) return "yesterday";
  if (day < 7) return `${day} days ago`;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
  }).format(new Date(iso));
}
